import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SignupService } from '../../services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { OGDetailsObject } from 'src/app/interfaces/shared.model';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { InstantCalculatorDisocuntCountdownService } from 'src/app/services/instant-calculator-disocunt-countdown.service';
import * as PackageOrdersAction from '../../store/shared/package-order/package-order.actions';
import { BrowserDetectService } from 'src/app/services/browser-detect.service';
import { parse } from 'path';

declare var Stripe: any;
@Component({
  selector: 'app-shipment-details-nohost-middle',
  templateUrl: './shipment-details-nohost-middle.component.html',
})
export class ShipmentDetailsNoHostMiddleComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    public signUpService: SignupService,
    private toastr: ToastrService,
    private watcherService: WatcherService,
    private router: Router,
    private store: Store<AppState>,
    private _icdcService: InstantCalculatorDisocuntCountdownService,
    private _cdr: ChangeDetectorRef,
    private location: Location,
    private browserDetectService: BrowserDetectService
  ) {}
  ngOnInit() {
    this.route.params.subscribe((params) => {
      const lang = params['lang'] ?? 'en';
      const countryCode = params['countryCode'] ?? 'us'; 

      setTimeout(() => {this.router.navigateByUrl(
        `/${lang}/shop-from/${countryCode}/getaddress-details`
      );}, 1000)
      
    });
  }
}
